import { call } from '../core'

export interface IContactRequestParams {
  // referCode?: number
  searchMsg: string
}

interface IContactInfo {
  name: string
  number: string
  // referCode?: number
}

export interface IContactResult {
  result: IContactInfo
}

export function getContact(params?: IContactRequestParams): Promise<IContactResult | Error> {
  return call('finGetContact', params)
}
